import { render, staticRenderFns } from "./WideLanguagesData.vue?vue&type=template&id=9a36117e&scoped=true&"
import script from "./WideLanguagesData.vue?vue&type=script&lang=js&"
export * from "./WideLanguagesData.vue?vue&type=script&lang=js&"
import style0 from "./WideLanguagesData.vue?vue&type=style&index=0&id=9a36117e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a36117e",
  null
  
)

export default component.exports